export default __webpack_public_path__ + "static/media/telefono.961ce35d.svg";